module.exports = __webpack_public_path__ + "assets/img/divider-aec796d1.png";